import React from "react";

const Upload = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.9107 17.9134C30.3144 16.5796 29.9011 15.0439 29.0465 13.9732C28.1365 12.8331 26.7204 12.1422 25.2679 12.0095C23.8152 11.8768 22.2529 12.277 21.0008 13.0254C19.2369 9.42482 14.0853 8.48193 10.4308 11.7201C8.89384 13.082 7.81363 14.7175 7.34197 16.7161C5.78841 16.5682 4.21598 17.3769 3.30924 18.6469C1.2064 21.5923 2.46907 26.4496 6.09826 27.3725C7.44435 27.7148 8.89055 27.7235 10.2697 27.8405C15.2586 28.2698 25.2049 29.4759 29.9795 27.3115C32.4136 26.2082 34.5268 23.4395 33.3958 20.679C33.1028 19.9635 32.5643 19.3501 31.9025 18.9528C31.5375 18.7335 29.8557 18.4984 29.8441 18.2475C29.8389 18.134 29.8776 18.0229 29.9107 17.9134Z"
        fill="#DFDFDF"
      />
      <path
        d="M32.6783 18.2731C34.2365 14.314 31.7211 9.72254 27.4226 9.21075C23.7614 8.77488 20.2192 11.6891 19.9394 15.366C19.6261 19.4822 23.3489 22.9384 27.4211 22.3865C29.7478 22.0713 31.8193 20.4559 32.6783 18.2731Z"
        fill="#222222"
      />
      <path
        d="M19.3031 15.3411C19.4645 13.2215 20.6851 11.2247 22.5689 9.99962C22.7197 9.90024 22.923 9.94402 23.0215 10.0955C23.1201 10.247 23.077 10.4496 22.9255 10.5481C21.2119 11.6628 20.1018 13.4731 19.9558 15.391C19.6595 19.2846 23.1836 22.5891 27.067 22.062C27.495 22.0019 27.5851 22.6524 27.1552 22.7108C22.8585 23.2923 18.9746 19.6515 19.3031 15.3411Z"
        fill="black"
      />
      <path
        d="M26.7703 13.3223C27.1226 13.3389 27.3934 13.6178 27.3755 13.945C27.2945 15.4247 27.2544 16.9258 27.2566 18.4071C27.2571 18.7351 26.9607 19.0085 26.618 19.0012C26.2657 19.0012 25.98 18.7363 25.9796 18.4086C25.9773 16.9069 26.0179 15.385 26.1001 13.8848C26.1186 13.5502 26.4289 13.3038 26.7703 13.3223Z"
        fill="white"
      />
      <path
        d="M27.0266 12.7228C27.695 13.1839 28.3623 14.0002 28.9136 14.3803C29.2041 14.5807 29.2769 14.9783 29.0767 15.2685C28.8765 15.5586 28.4784 15.6315 28.1888 15.4316C27.6673 15.0722 27.1933 14.5449 26.7363 14.1284C26.3971 14.4822 25.9593 14.8879 25.4128 15.3551C25.1452 15.5841 24.7419 15.5523 24.5128 15.2848C24.2837 15.0167 24.3151 14.6137 24.5832 14.3845C25.3236 13.7514 25.8563 13.2347 26.1663 12.8485C26.374 12.59 26.7488 12.5313 27.0266 12.7228Z"
        fill="white"
      />
      <path
        d="M9.02952 16.2097C8.94452 16.1793 8.90009 16.086 8.93045 16.0006C10.1006 12.7147 13.4733 10.6991 16.9419 11.2542C17.0311 11.2686 17.0918 11.3527 17.0777 11.4418C17.0631 11.5313 16.9774 11.5901 16.8902 11.5777C13.5954 11.0501 10.3625 12.9558 9.23855 16.1106C9.20786 16.1973 9.11164 16.2399 9.02952 16.2097Z"
        fill="black"
      />
      <path
        d="M31.8043 16.1719C31.9714 14.8865 31.6125 13.5614 30.8197 12.5365C30.7643 12.4652 30.7774 12.3623 30.849 12.307C30.9193 12.2514 31.0221 12.2642 31.0785 12.3364C31.9242 13.4298 32.3071 14.843 32.129 16.2141C32.1007 16.4291 31.7767 16.3864 31.8043 16.1719Z"
        fill="black"
      />
      <path
        d="M21.1565 26.945C21.066 26.943 20.9948 26.8678 20.9971 26.7773C20.9992 26.6872 21.0837 26.615 21.1648 26.6179C24.2136 26.6945 27.5304 26.7532 30.0073 24.783C30.0789 24.727 30.1815 24.7386 30.2375 24.8092C30.2937 24.8801 30.2818 24.9831 30.2113 25.0393C27.6719 27.0584 24.2798 27.0249 21.1565 26.945Z"
        fill="black"
      />
      <path
        d="M23.6866 8.32305C22.9531 7.65763 21.9286 7.29872 20.9348 7.36104C20.7577 7.36934 20.5989 7.23577 20.5873 7.05518C20.5758 6.87494 20.7126 6.71928 20.8932 6.70777C22.0728 6.63363 23.2513 7.04399 24.1263 7.83853C24.2603 7.95997 24.2701 8.16675 24.1488 8.30068C24.0274 8.4344 23.8206 8.44481 23.6866 8.32305Z"
        fill="black"
      />
      <path
        d="M24.0748 6.79298C23.562 5.88721 23.1159 4.93417 22.7488 3.9597C22.6847 3.79062 22.7704 3.60173 22.9394 3.53814C23.1082 3.47455 23.2975 3.55987 23.361 3.72894C23.7164 4.67177 24.1482 5.59414 24.6443 6.47016C24.7334 6.62773 24.6782 6.82717 24.5209 6.91634C24.3611 7.00623 24.1626 6.94815 24.0748 6.79298Z"
        fill="black"
      />
      <path
        d="M25.5631 7.26099C25.1091 6.03755 25.3371 4.58465 26.145 3.55967C26.2571 3.41842 26.4631 3.39413 26.6044 3.50534C26.7463 3.61721 26.7707 3.82303 26.6587 3.96493C25.9895 4.81443 25.7999 6.01901 26.1768 7.03344C26.2398 7.20283 26.1535 7.39107 25.9839 7.45404C25.8191 7.51597 25.6272 7.43392 25.5631 7.26099Z"
        fill="black"
      />
      <path
        d="M5.25982 25.5276C4.20194 24.9857 3.50265 23.8233 3.51959 22.6351C3.52088 22.5452 3.59375 22.4736 3.68323 22.4736H3.68546C3.77592 22.4751 3.84815 22.5494 3.84688 22.6395C3.83185 23.7064 4.45954 24.75 5.40876 25.2361C5.48931 25.2773 5.52127 25.3761 5.48003 25.4562C5.43783 25.5384 5.33834 25.5678 5.25982 25.5276Z"
        fill="black"
      />
    </svg>
  );
};

export default Upload;
